import type { SxProps, Theme } from "@mui/material/styles";

import {
  onPrimarySurfaceColor,
  unreadCountBadgeColors
} from "@/src/theme/helpers";

/**
 * Bell trigger in the header. The open fill used to be Misc/Outline Border,
 * which is a border token: in dark mode it reads as a washed white disc, and
 * in light mode it tints the red AppBar a muddy brown. Action/Selected is the
 * selected-control wash in both modes.
 */
export const notificationMenuButtonSx =
  (open: boolean): SxProps<Theme> =>
  (muiTheme) => ({
    backgroundColor: open ? muiTheme.palette.action.selected : undefined,
    "&:hover": {
      backgroundColor: muiTheme.palette.action.hover
    }
  });

/** Bell icon sitting on the AppBar (Primary/Main in light, dark surface in dark). */
export const notificationBellIconSx: SxProps<Theme> = (muiTheme) => ({
  color: onPrimarySurfaceColor(muiTheme)
});

/** Unread count on the bell trigger. */
export const notificationBadgeSx: SxProps<Theme> = (muiTheme) => ({
  "& .MuiBadge-badge": {
    borderRadius: "60%",
    right: 4,
    top: 3,
    minWidth: "18px",
    height: "18px",
    fontSize: muiTheme.typography.caption.fontSize,
    px: 0.5,
    py: 0,
    ...unreadCountBadgeColors(muiTheme)
  }
});

/** Popover surface: paper, no MUI elevation overlay, real outline instead of a drop-shadow-only edge. */
export const notificationPopoverPaperSx: SxProps<Theme> = (muiTheme) => ({
  backgroundColor: muiTheme.palette.background.paper,
  backgroundImage: "none",
  border: `1px solid ${muiTheme.palette.misc.outlineBorder}`
});
